<script>
    import Header from "../header.svelte"
    import ResponsiveTable from '../../utils/responsivetable3.svelte';
    import {link, location, push, pop, replace} from 'svelte-spa-router';
    import IFTAInput from "../../utils/iftainput.svelte";

    let is_busy = false;
    let content_title = "Settings - Features"

    let enable_referrals = true;
    let enable_gift_cards = true;

    let book_now_contact_feature = "Book Now or Contact Us";

    let auto_charge_clients_overnight = true;

</script>

<Header title="{content_title}" bind:is_busy={is_busy} />

<div class="contentholder">

    <div class="ff rowwrap featuresettings">
        <IFTAInput 
        type="toggle" 
        label="Toggle Referrals" 
        helper_text="Enable / Disable Referrals" 
        bind:value={enable_referrals}
        />
        <IFTAInput 
        type="toggle" 
        label="Toggle Gift Cards" 
        helper_text="Enable / Disable Gift Cards" 
        bind:value={enable_gift_cards}
        />
        <IFTAInput 
        type="toggle" 
        label="Toggle Client Auto-Charge" 
        helper_text="Auto charge clients over night" 
        bind:value={auto_charge_clients_overnight}
        />
        <IFTAInput 
        type="select" 
        label="Book Now / Contact Us" 
        helper_text="Enable / Disable Book Now & Contact Us" 
        bind:value={book_now_contact_feature}
        select_options={["Book Now or Contact Us", "Book Now", "Contact Us"]}
        />
    </div>    


    <div class="buttonholder">
        <button class="savebutton" on:click={() => {console.log("hello");}} ><i class="far fa-save"></i> Save Settings</button>
    </div>
    
</div>


<style>
.buttonholder {
        margin-top: 10px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .buttonholder button {
        max-width: 300px;
        /* width: 100%; */
        /* background-color: #357a38; */
        /* color: white; */
    }
    .buttonholder button.savebutton {
        color: white;
        background-color: #357a38;
    }
    :global(.rowwrap .group) {
        min-width: 300px;
        max-width: 300px;
    }

    @media (max-device-width: 1024px), (max-width: 1023px) {
        .contentholder {
            padding: 0px;
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
        }
        .buttonholder {
            /* max-width: 100%; */
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        .buttonholder button{
            max-width: 100%;
            width: 100%;
        }
        :global(.rowwrap .group) {
            min-width: 100%;
            max-width: 100%;
        }

    }

</style>